// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lopunny_mega: PokeData = {
  "id": 10088,
  "name": "lopunny-mega",
  "height": 13,
  "weight": 283,
  "base_experience": 203,
  "types": [
    PokeType.NORMAL,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "pound",
    "jump-kick",
    "agility",
    "quick-attack",
    "defense-curl",
    "high-jump-kick",
    "dizzy-punch",
    "splash",
    "foresight",
    "endure",
    "charm",
    "return",
    "baton-pass",
    "mirror-coat",
    "magic-coat",
    "bounce",
    "healing-wish",
    "entrainment",
    "after-you",
    "rototiller",
    "baby-doll-eyes"
  ],
  "moves": [
    "jump-kick",
    "quick-attack",
    "splash",
    "healing-wish",
    "rototiller",
    "refresh",
    "close-combat",
    "tri-attack",
    "bulk-up",
    "double-kick",
    "meteor-assault",
    "leer",
    "scratch"
  ],
  "evolution_chain": {
    "id": 220,
    "item": null,
    "species": [
      {
        "name": "buneary",
        "order": 454,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lopunny",
        "order": 455,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 427,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 154,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
